// AllMembers.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './AllMembers.css'; // Optional: for styling
import loadingGif from '../CMD/loading.gif';

function AllMembers() {
  const [teamMembers, setTeamMembers] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeamMembers = async () => {
      try {
        const response = await axios.get('https://sirius.runasp.net/api/Team/GetAllVisibleTeamMembers');
        setTeamMembers(response.data);
      } catch (error) {
        console.error('Error fetching team members:', error);
      }finally {
        setLoading(false);
      }
    };

    fetchTeamMembers();
  }, []);
  if (loading) {
    return (
      <div style={{ margin:'50px auto', textAlign:'center',  width:'200px',height:'200px' }}>
        <img width={'100%'} src={loadingGif} alt="Loading..." />
      </div>
    );
  }
  const handleReadMore = (memberId) => {
    navigate(`/TeamMember/${memberId}`);
  };

  return (
    <div className="all-members-container">
      {teamMembers.map((member) => (
        <div className="member-card" key={member.memberId}>
             <img 
            src={`https://sirius.runasp.net/${member.photoPath}`} 
            alt={member.userName} 
            style={{width:'150px',height:'150px',borderRadius:'50%',border:'1px solid coral'}}
          />
          <h3>{member.userName}</h3>
          <h4>{member.position}</h4>
          <p>{member.summary.substring(0, 50)}{member.summary.length > 50 ? '...' : ''}</p>
          <button onClick={() => handleReadMore(member.memberId)}>Read More</button>
        </div>
      ))}
    </div>
  );
}

export default AllMembers;
